import { ISearchFilterRef } from '@/components';
import { useRef } from 'react';

export const useSearchFilterRef = (initialValue?: ISearchFilterRef) => {
	const searchFilterRef = useRef<ISearchFilterRef>(initialValue ?? null);

	return searchFilterRef;
};
